import type { BookingDetailsState } from '../../domain/types'
import { isDatePast } from '@/scopes/common/domain/utils/dates'

export function isPastBooking(state: BookingDetailsState, currentDate: Date = new Date()): boolean {
  return isDatePast(state.rawReturnDate, currentDate)
}
